module.exports = __webpack_public_path__ + "img/nike-talk-3.1f7de471.jpg";